<style>
</style>
<script>

  export default{
    props: ["attr", "fieldValue", "label"],
    methods: {
      callBusinessRule: function() {
        if (this.attr.eventOnClick) {
          this.$emit('callBusinessRule', this.attr.eventOnClick);
        }
      }
    },
    computed: {
      alingButton: function () {
        if (this.attr.alingButton) {
          return "marginTop25px"
        }
        return ""
      }
    }
  }



</script>
<template>
  <div style="display: inline">
    <el-button
      size="small"
      type="primary"
      @click.prevent="callBusinessRule()"
      :disabled="attr.disableField"
      :class="alingButton"
    >
      {{label}}
    </el-button>
  </div>
</template>
<style scoped>
  .marginTop25px {
    margin-top: 25px;
  }
  .el-button {
    margin-bottom: 22px;
  }
</style>



// WEBPACK FOOTER //
// SgsRenderButton.vue?d3236c7c